export const pageNames = {
  HOME: 'home',
  TOPICS: 'home',
  ARTICLE: 'article',
  SEARCH: 'search',
  CONTACT_US: 'contactUs',
  CALL_US: 'callUs',
  EMAIL: 'email',
  EMAIL_NOT_TCODE: 'emailNoTCode',
};

export const loaderTypes = {
  SPINNER: 'spinner',
  TEXT: 'text',
  SPINNER_WITH_TEXT: 'spinner_with_text',
};

export const spinnerSizes = {
  SMALL: 'sm',
  MEDIUM: 'md',
  LARGE: 'lg',
  X_LARGE: 'xl',
};

export const OMNI_CHANNEL_API_SESSION_KEY = 'OmniChannelAPITriggered';
export const BNA_CHANNEL = 'BNA';

export const experiences = {
  PERSONAL: 'personal',
  BUSINESS: 'business',
  TECHNICAL: 'technical',
};

export const QUALTRICS_FEEDBACK_SURVEY_ID = 'smarthelpnodeweb-feedbacklink-newdesign-jul2021';

export const urlConstants = {
  CONTACT_US_URL: '/smarthelp/contact-us',
  RESOLUTION_CENTER: '/disputes',
};

export const trackerConstants = {
  refund: 'refund',
  dispute: 'dispute',
};

export const contactOptionIcons = {
  MESSAGE: 'message',
  CALLUS: 'callus',
  MESSAGE_US: 'message_us',
  COMMUNITY: 'community',
  RES_CENTER: 'res_center',
  SELLER: 'seller',
  CHAT: 'chat',
  ARTICLE: 'article',
  PHONE: 'phone',
};

export const chatBotMessageUsRefIdsMapping = {
  GENPOOL_CONTACT_US: 'GENPOOL|contactUsPage',
  GENERIC: 'GENPOOL',
  FINAL_INTENT: 'finalIntent',
  GENPOOL_ARTICLE_PAGE: 'GENPOOL|articlePage',
  GENPOOL_HOME_PAGE: 'GENPOOL|homePage',
  RES_CENTER: 'seller',
};

export const intentType = {
  GENERIC: 'GENERIC',
  TOPIC: 'TOPIC',
};

export const intents = {
  CONTACT_US_PAGE: 'contactUSpage',
  SEARCH: 'SEARCH',
  OVERFLOW: 'OVERFLOW',
  PAYMENTHOLD: 'PAYHOLD001',
  FILE_DISPUTE: 'DISPDISPUTE001',
  DISPUTE_STATUS: 'DISPSTATUS001',
  REFUND: 'PAYREF004',
  LIMITATION: 'DISPLIM001',
  TRANSFER: 'PAYWITHD002',
  UNAUTHORIZED_TRANSACTION: 'PASSWORD002',
  PAYMENT_DECLINE: 'PAYDEC001',
  PAY_IN_4: 'TXNPAYLATINSTAL',
  PAY_IN_3: 'TXNPAYLATINSTAL',
  PAYPAY_CREDIT: 'CREDPROD001',
  BUSINESS_DEBIT_MASTERCARD: 'CARDDEBIT001',
  PAYPAL_RATENZAHLUNG: 'CREDBILL001',
  PAYMENT_DECLINE_OCP: 'TXNPMTDCLN',
  ADD_CARD: 'FIADDCARD',
};

export const chatbotDefaultConfig = {
  LINK: 'smarthelp-chat-bot-contact-us',
  chatBotTopicRefId: chatBotMessageUsRefIdsMapping.GENPOOL_CONTACT_US,
};

export const contactOptionType = {
  DEFAULT: 'default',
  FINAL_INTENT: 'final_intent',
};

export const contactOptionsFptiPages = {
  FINAL_INTENT: 'final-intent',
};
